import { useClipboard } from "shared/lib/clipboard/useClipboard"
import { useEvent } from "shared/lib/useEvent"

import { ProductQuickInfos } from "entities/products/types/QuickInfos"

function stripHtmlAndFormatLists(html: string): string {
  let text = html
  text = text.replace(/<li[^>]*>/gi, "\n- ")
  text = text.replace(/<\/li>/gi, "")
  text = text.replace(/<\/?[uo]l[^>]*>/gi, "")
  text = text.replace(/<br\s*\/?>/gi, "\n")
  text = text.replace(
    /<\/(h[1-6]|p|div|section|article|header|footer|nav)>/gi,
    "\n"
  )
  text = text.replace(/<[^>]+>/g, "")
  text = text
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
  text = text.replace(/\n\s*\n\s*\n/g, "\n\n").trim()
  return text
}

function formatQuickInfosForClipboard(
  quickInfos: ProductQuickInfos | undefined
): string {
  if (!quickInfos) return ""

  return Object.values(quickInfos)
    .map(widget => {
      const label = widget.get("label") || ""
      const text = widget.get("text") || ""
      const formattedText = stripHtmlAndFormatLists(text)
      return `${label}\n${formattedText}`
    })
    .join("\n\n")
}

export function useProductQuickInfosClipboard(
  quickInfos: ProductQuickInfos | undefined
) {
  const { copy } = useClipboard()

  const handleCopyToClipboard = useEvent(() => {
    const text = formatQuickInfosForClipboard(quickInfos)
    if (text) {
      copy(text)
    }
  })

  return { copyToClipboard: handleCopyToClipboard }
}
